import { InsightWidget } from '@/store/beneficiary-insights/types'

import { EditModeCard } from './EditModeCard'
import { ShowModeCard } from './ShowModeCard'

export function InsightsDashboardLayout({
  widgets,
  editMode,
}: {
  widgets: InsightWidget[]
  editMode: boolean
}) {
  const colSpan = (widget: InsightWidget) => {
    return (
      ['col-span-1', 'col-span-2', 'col-span-3', 'col-span-4', 'col-span-5', 'col-span-6'][
        widget.width - 1
      ] ?? 'col-span-2'
    )
  }
  const rowSpan = (widget: InsightWidget) => {
    return (
      ['row-span-1', 'row-span-2', 'row-span-3', 'row-span-4', 'row-span-5', 'row-span-6'][
        widget.height - 1
      ] ?? 'col-span-2'
    )
  }

  return (
    <div className="grid grid-cols-6 grid-rows-20 gap-4">
      {widgets.map((widget) =>
        editMode ? (
          <EditModeCard
            key={widget.id}
            widget={widget}
            colSpanCss={colSpan(widget)}
            rowSpanCss={rowSpan(widget)}
          />
        ) : (
          <ShowModeCard
            key={widget.id}
            widget={widget}
            colSpanCss={colSpan(widget)}
            rowSpanCss={rowSpan(widget)}
          />
        ),
      )}
    </div>
  )
}
